import { mergeStyles } from '@fluentui/react';
import { CoherenceTheme } from '@coherence-design-system/styles';
import {
  FOOTER_SMALL_BREAKPOINT,
  FOOTER_X_SMALL_BREAKPOINT,
  MOBILE_NAV_MAX_WIDTH_BREAKPOINT,
} from '../../app/common/constants/SiteConstants';

export const footerClassName = mergeStyles({
  height: '48px',
  marginLeft: '48px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  borderTop: `1px solid ${CoherenceTheme.palette.neutralLight}`,
  selectors: {
    [MOBILE_NAV_MAX_WIDTH_BREAKPOINT]: {
      marginLeft: 0,
    },
  },
});

export const copyrightStyle = mergeStyles({
  marginRight: 56,
  marginLeft: 86,
  selectors: {
    [FOOTER_X_SMALL_BREAKPOINT]: {
      display: 'none',
    },
  },
});

export const privacyLinkStyle = mergeStyles({
  minHeight: '24px',
  display: 'inline-flex',
  alignItems: 'center',
  selectors: {
    '&&:focus-visible': {
      outline: '2px solid #0078d4',
      outlineOffset: '2px',
      borderRadius: '2px',
    },
    [FOOTER_SMALL_BREAKPOINT]: {
      display: 'none',
    },
  },
});
